const MagicStar = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
      <path
        d="M14.4072 3.44983L14.3489 6.60815C14.3406 7.04148 14.6156 7.6165 14.9656 7.87483L17.0323 9.44148C18.3573 10.4415 18.1406 11.6665 16.5572 12.1665L13.8656 13.0081C13.4156 13.1498 12.9406 13.6415 12.8239 14.0998L12.1822 16.5498C11.6739 18.4831 10.4072 18.6748 9.35724 16.9748L7.89056 14.5998C7.62389 14.1665 6.99057 13.8415 6.49057 13.8665L3.70726 14.0082C1.7156 14.1082 1.14892 12.9582 2.44892 11.4415L4.0989 9.52481C4.40724 9.16648 4.5489 8.49982 4.40723 8.04982L3.56561 5.35815C3.07394 3.77481 3.95726 2.89983 5.53226 3.41649L7.99061 4.22483C8.40727 4.35816 9.03226 4.26648 9.38226 4.00815L11.9489 2.15815C13.3323 1.15815 14.4406 1.7415 14.4072 3.44983Z"
        stroke={color}
        strokeWidth="1.15385"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.2554 18.3331L15.7305 15.8081"
        stroke={color}
        strokeWidth="1.15385"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default MagicStar;
